// Where each project assumption the sizing reads is edited, as a deep link:
// the page (and its tab) plus the id of the field's wrapper, which
// navigation/useFieldFocus scrolls to, focuses and highlights.
const PV = (pvTab, id) => ({ to: `/project/asset?tab=pv&pv=${pvTab}`, hash: `field-${id}` });

export const FIELD_LINKS = {
  tilt: PV("system", "pv-tilt"),
  azimuth: PV("system", "pv-azimuth"),
  installation: PV("system", "pv-installation"),
  layout: { to: "/project/asset?tab=pv&pv=design&design=layout", hash: "field-pv-layout-pitch" },
  surface: { to: "/project/asset?tab=general", hash: "field-site-surface" },
  area: { to: "/project/asset?tab=general", hash: "field-site-area" },
  degradation: PV("equipment", "pv-degradation"),
  module: PV("equipment", "pv-module"),
  inverter: PV("equipment", "pv-inverter"),
  soiling: PV("losses", "pv-loss-soiling"),
  shading: PV("losses", "pv-loss-shading"),
  otherLosses: PV("losses", "pv-loss-other"),
  wiring: { to: "/project/asset?tab=pv&pv=losses" },
  transposition: PV("modelling", "pv-model-transposition"),
  aoi: PV("modelling", "pv-model-aoi"),
  spectral: PV("modelling", "pv-model-spectral"),
  thermal: PV("modelling", "pv-model-thermal"),
  injection: { to: "/project/asset?tab=general", hash: "field-btm-injection" },
  exportLimit: { to: "/project/asset?tab=grid", hash: "field-grid-export-limit" },
  transformer: { to: "/project/asset?tab=grid", hash: "field-grid-transformer" },
  escalation: { to: "/project/asset?tab=general", hash: "field-btm-escalation" },
  horizon: { to: "/feasibility/simulation", hash: "field-sim-horizon" },
  discount: { to: "/feasibility/economics", hash: "field-econ-discount" },
  inflation: { to: "/feasibility/economics", hash: "field-econ-inflation" },
  grant: { to: "/feasibility/economics", hash: "field-econ-grant" },
  insurance: { to: "/feasibility/economics", hash: "field-econ-insurance" },
  investment: { to: "/feasibility/economics", hash: "field-econ-pv-investment" },
  equipmentPrice: { to: "/feasibility/economics", hash: "field-econ-equipment-modules" },
  simpleInvestment: { to: "/feasibility/economics", hash: "field-econ-simple-pv" },
  om: { to: "/feasibility/economics", hash: "field-econ-om" },
  simpleOm: { to: "/feasibility/economics", hash: "field-econ-simple-pv-om" },
  landLease: { to: "/feasibility/economics", hash: "field-econ-land-lease" },
  incomeTax: { to: "/feasibility/economics", hash: "field-econ-income-tax" },
  salvage: { to: "/feasibility/economics", hash: "field-econ-salvage" },
  incentive: { to: "/feasibility/economics", hash: "field-econ-incentive" },
  loadGrowth: { to: "/feasibility/technical", hash: "field-demand-growth" },
  // The consumption and tariff tabs of the technical page (it scrolls to them itself).
  demand: { to: "/feasibility/technical?section=demand" },
  tariff: { to: "/feasibility/technical?section=tariffs" },
};

export function fieldLinkHref(key) {
  const link = FIELD_LINKS[key];
  if (!link) return null;
  return link.hash ? `${link.to}#${link.hash}` : link.to;
}
